export default {
  name: "blacklist",
  class: "h-6 w-6",
  box: 24,
  svg: `<path d="M22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22" stroke="fillcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.0028 2.04688C13.0028 2.04688 16.0028 5.99687 16.0028 11.9969M11.0028 21.9469C11.0028 21.9469 8.00281 17.9969 8.00281 11.9969C8.00281 5.99687 11.0028 2.04688 11.0028 2.04688M2.63281 15.4969H12.0028M2.63281 8.49687H21.3728" stroke="fillcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.6875 14L17.5 16.1875L15.3125 14L14 15.3125L16.1875 17.5L14 19.6875L15.3125 21L17.5 18.8125L19.6875 21L21 19.6875L18.8125 17.5L21 15.3125L19.6875 14Z" fill="fillcolor"/>`,
};
